import React, { FC } from 'react'

interface ProfileAddEventProps {
  size?: number
}

/**
 * 活动专用的圆形加号图标组件
 * 白色背景 + 棕红色加号，用于圣诞节等活动期间的头像编辑按钮
 */
export const ProfileAddEvent: FC<ProfileAddEventProps> = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none">
    <path
      d="M8 1C11.866 1 15 4.13401 15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1Z"
      fill="white"
    />
    <path
      d="M7.99609 4.00586C8.41031 4.00586 8.74609 4.34165 8.74609 4.75586V7.24609H11.2441C11.6584 7.24609 11.9941 7.58188 11.9941 7.99609C11.9941 8.41031 11.6584 8.74609 11.2441 8.74609H8.74609V11.2441C8.74609 11.6584 8.41031 11.9941 7.99609 11.9941C7.58188 11.9941 7.24609 11.6584 7.24609 11.2441V8.74609H4.75586C4.34165 8.74609 4.00586 8.41031 4.00586 7.99609C4.00586 7.58188 4.34165 7.24609 4.75586 7.24609H7.24609V4.75586C7.24609 4.34165 7.58188 4.00586 7.99609 4.00586Z"
      fill="#9C4844"
    />
  </svg>
)

export default ProfileAddEvent
